<div class="container-fluid">
  <div class="row col-md-12 d-flex align-items-center">
    <!-- <div class="col-md-8">
      <h4 *ngIf="this.currentState == 'ACTV'">Company Info</h4>
      <h4 *ngIf="this.currentState != 'ACTV'">Create New Client</h4>
      <div *ngIf="this.currentState != 'ACTV'" class="mat-subheading-1 titleColor">Enter client information below</div>
    </div> -->
    <div class="col-md-8 titlePortion pl-0">
      <h5 *ngIf="creationType == 'parent'">View/Edit</h5>
      <p *ngIf="creationType == 'parent'" class="mb-1">Company Information below</p>
      <h5 *ngIf="creationType == 'associate'">Create Company (Associated)</h5>
      <p *ngIf="creationType == 'associate'" class="mb-1">Parent Company - {{parentData?.name}}</p>
      <h5 *ngIf="creationType == 'associateView'">View/Edit (Associated)</h5>
      <p *ngIf="creationType == 'associateView'" class="mb-1">Parent Company - {{parentData?.name}}</p>
      <h5 *ngIf="!creationType">Create New (Parent Company)</h5>
      <p *ngIf="!creationType" class="mb-1">Add Company Information</p>
      <a class="link back-button pl-0 pr-3 ml-0 back-link mt-3 back-btn-white-bg" (click)="onClickBack()">
        <i class="fa fa-chevron-circle-left " aria-hidden="true"></i> Back</a>
    </div>
  </div>
  <div class="row col-md-12 d-flex bg-white" *ngIf="tabsList">
    <p-tabView [activeIndex]="activeTabIndex" class="summaryTask-tab w-100" (onChange)="handleChange($event)">
      <p-tabPanel *ngFor="let item of tabsList | slice:0:2; let i = index;" [disabled]="(!companyId || 'null'== companyId)  && i > 0">
        <ng-template pTemplate="header">
          <div class="row">
            <hr *ngIf="i !== 0" style="width: 25%;position: absolute;top: 3rem;" />
            <span class="header-icon border rounded-circle p-3" [ngClass]="{'active':i == activeTabIndex}">
              <img alt="" src='{{ "assets/images/" + item.tabIconName + "_icon.png"}}'>

            </span>
            <hr *ngIf="i !== 1" style="width: 25%;position: absolute;top: 3rem;right:0" />
          </div>
          <label>{{ item.tabName }}</label>
        </ng-template>
        <ng-template pTemplate="content">
          <div [ngSwitch]="i">
            <app-company-info *ngSwitchCase="0" (notify)="parentListener($event)"
              (companyId)="idListener($event)"></app-company-info>
            <app-other-document *ngSwitchCase="1" (notify)="parentListener($event)"
              [companyId]="companyId"></app-other-document>
            <!-- <app-select-roles *ngSwitchCase="2" (notify)="parentListener($event)" [companyId]="companyId"></app-select-roles>
              <app-creating-users *ngSwitchCase="3" (notify)="parentListener($event)" [companyId]="companyId"></app-creating-users>
              <app-manage-beneficiary *ngSwitchCase="4" (notify)="parentListener($event)" [companyId]="companyId"></app-manage-beneficiary>
              <app-summary-info *ngSwitchCase="5" (notify)="parentListener($event)" [companyId]="companyId"></app-summary-info> -->
          </div>
        </ng-template>


      </p-tabPanel>

    </p-tabView>
  </div>
</div>